import MainPage from "../pages/main/MainPage";
import { RouteType } from "../types/route.type";

const publicRoutes: RouteType[] = [
  {
    id: "main",
    path: "*",
    component: MainPage,
  },
];

const restrictedRoutes: RouteType[] = [
 
];
const privateRoutes: RouteType[] = [
  
];

export { publicRoutes, restrictedRoutes, privateRoutes };
